export default {
  title: "Акциялар",
  newPromotion: "Жаңы акция",
  createNewPromo: "Жаңы акция түзүү",
  creatingNewPromo: "Жаңы акция түзүлүүдө",
  name: "Акциянын аталышы",
  promoEditor: "Акциялар редактору",
  cashback: "Кешбэк пайызы",
  discount: "Жеңилдик пайызы",
  activate: "Акцияны активдештирүү",
  deactivate: "Акцияны өчүрүү",
  noPromotions: "Сизде азырынча акциялар жок",
  createWarning: "*Бир соода жайына үч активдүү акцияга чейин",
  createWarningLimit:
    "Бул соода жайы үчүн акциялардын максималдуу саны түзүлгөн",
  headersList: {
    name: "Акциянын аталышы",
    tradingPoint: "Соода жайы",
    cashback: "Кешбэк пайызы",
    discount: "Жеңилдик пайызы",
  },
  delete: "Чын эле өчүргүңүз келеби ",
  aboutChapter: "Бөлүм жөнүндө",
  aboutChapterDescriptions: [
    "«Акциялар» бөлүмү ар кандай жеңилдик жана сый акы пайызы бар товарларды башкарууга жардам берет. Сиз түзгөн акция RC KASSA тиркемесинде көрсөтүлөт жана дароо колдонсо болот.",
    "Бир соода жайында бир убакта 3 активдүү акцияга чейин болушу мүмкүн.",
  ],
  deletePromo: "Акцияны өчүрүү",
};
